import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import { Button, Row, Col, Form, Label, Input } from "reactstrap";
import axios from "axios";
import moment from "moment";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from "uuid";
import { puede } from "../../../../permisos/permisos";

// Compra directa de material: crea la OC ya recibida, la compra (CxP)
// y la entrada al inventario de materia prima en un solo paso.
function CompraDirectaCreate() {
  const { user } = useContext(AuthContext);
  const URL_COMPRAS = process.env.REACT_APP_URL_COMPRAS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const headers = { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } };

  const [telas, setTelas] = useState([]);
  const [proveedores, setProveedores] = useState([]);

  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [proveedor, setProveedor] = useState("");
  const [facturaProveedor, setFacturaProveedor] = useState("");
  const [impuestos, setImpuestos] = useState("No");
  const [moneda, setMoneda] = useState("MXN");
  const [tipoCambio, setTipoCambio] = useState(0);
  const [observaciones, setObservaciones] = useState("NA");
  const [validaBoton, setValidaBoton] = useState(true);

  const [partidas, setPartidas] = useState([
    { id: uuidv4(), telas: "", colores: "", arrayColores: [], unidad: "", cantidad: 0, precio: 0 },
  ]);

  useEffect(() => {
    axios.get(URL_TELAS, headers).then((r) => setTelas(r.data)).catch((e) => console.log(e));
    axios.get(URL_PROVEEDORES, headers).then((r) => setProveedores(r.data)).catch((e) => console.log(e));
  }, []);

  function setPartida(id, campo, valor) {
    setPartidas((prev) =>
      prev.map((p) => {
        if (p.id !== id) return p;
        const np = { ...p, [campo]: valor };
        if (campo === "telas") {
          const tela = telas.find((t) => t._id === valor);
          np.unidad = tela ? tela.unidad : "";
          np.precio = tela ? tela.costo : 0;
          // Solo los colores dados de alta en el material.
          np.arrayColores = (tela && tela.colores) || [];
          np.colores = "";
        }
        return np;
      })
    );
  }
  function addPartida() {
    setPartidas((prev) => [
      ...prev,
      { id: uuidv4(), telas: "", colores: "", arrayColores: [], unidad: "", cantidad: 0, precio: 0 },
    ]);
  }
  function removePartida(id) {
    setPartidas((prev) => (prev.length > 1 ? prev.filter((p) => p.id !== id) : prev));
  }

  const subtotal = partidas.reduce((t, p) => t + Number(p.cantidad || 0) * Number(p.precio || 0), 0);
  const iva = impuestos === "Si" ? subtotal * 0.16 : 0;
  const total = subtotal + iva;

  function guardar(event) {
    event.preventDefault();
    const validas = partidas.filter((p) => p.telas && Number(p.cantidad) > 0);
    if (!proveedor || !validas.length) {
      Swal.fire("Atención", "Selecciona proveedor y agrega al menos una partida con cantidad", "warning");
      return;
    }
    setValidaBoton(false);
    axios
      .post(
        `${URL_COMPRAS}Directa`,
        {
          fecha,
          proveedor,
          factura_proveedor: facturaProveedor || "NA",
          observaciones: observaciones || "Compra Directa",
          impuestos,
          moneda,
          tipoCambio: Number(tipoCambio) || 0,
          user: user.id,
          partidas: validas.map((p) => ({
            telas: p.telas,
            ...(p.colores ? { colores: p.colores } : {}),
            unidad: p.unidad,
            cantidad: Number(p.cantidad),
            precio: Number(p.precio) || 0,
          })),
        },
        headers
      )
      .then((r) => {
        axios.post(URL_LOGS, { tipo: "Crear Compra Directa", detalle: `OC ${r.data.ordenCompra} / Compra ${r.data.compra}`, user: user.id }, headers);
        Swal.fire("Good job!", `Creada con éxito. OC ${r.data.ordenCompra} / Compra ${r.data.compra}`, "success");
        setTimeout(() => { window.location.href = "/ListadoCompras"; }, 1200);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data.message || JSON.stringify(error.response.data) : error}`,
        });
      });
  }

  return (
    <>
      <Header />
      <br />
      <div className="container">
        {puede(user, "compras.directa.ver") ? (
          <div className="card col-12">
            <div className="page-header">
              <div>
                <h3 className="page-title">
                  <i className="fas fa-bolt" style={{ marginRight: 8, color: "#f59e0b" }} />
                  Compra Directa
                </h3>
                <p className="page-subtitle">Crea la orden, la compra y la entrada al inventario en un paso</p>
              </div>
            </div>
            <Form onSubmit={guardar}>
              <Row>
                <Col md={2}>
                  <Label>Fecha</Label>
                  <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
                </Col>
                <Col md={3}>
                  <Label>Proveedor</Label>
                  <Input type="select" value={proveedor} onChange={(e) => setProveedor(e.target.value)}>
                    <option value="">Selecciona</option>
                    {proveedores
                      .sort((a, b) => (a.nombre_comercial > b.nombre_comercial ? 1 : -1))
                      .map((p) => (
                        <option key={p._id} value={p._id}>{p.nombre_comercial}</option>
                      ))}
                  </Input>
                </Col>
                <Col md={3}>
                  <Label>Factura Proveedor</Label>
                  <Input type="text" value={facturaProveedor} onChange={(e) => setFacturaProveedor(e.target.value)} />
                </Col>
                <Col md={2}>
                  <Label>Impuestos</Label>
                  <Input type="select" value={impuestos} onChange={(e) => setImpuestos(e.target.value)}>
                    <option value="No">No</option>
                    <option value="Si">Si</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>Moneda</Label>
                  <Input type="select" value={moneda} onChange={(e) => { setMoneda(e.target.value); if (e.target.value === "MXN") setTipoCambio(0); }}>
                    <option value="MXN">Pesos (MXN)</option>
                    <option value="USD">Dólares (USD)</option>
                  </Input>
                </Col>
                {moneda === "USD" && (
                  <Col md={2}>
                    <Label>Tipo de cambio</Label>
                    <Input type="number" placeholder="Ej. 17.50" value={tipoCambio} onChange={(e) => setTipoCambio(e.target.value)} />
                  </Col>
                )}
              </Row>
              <br />
              <Label>Observaciones</Label>
              <Input type="textarea" value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
              <br />
              <h5>Partidas</h5>
              <Row className="align-items-center" style={{ marginBottom: 4 }}>
                <Col md={4}><small className="text-muted" style={{ fontWeight: 600 }}>Material</small></Col>
                <Col md={2}><small className="text-muted" style={{ fontWeight: 600 }}>Color</small></Col>
                <Col md={1}><small className="text-muted" style={{ fontWeight: 600 }}>Unidad</small></Col>
                <Col md={2}><small className="text-muted" style={{ fontWeight: 600 }}>Cantidad</small></Col>
                <Col md={2}><small className="text-muted" style={{ fontWeight: 600 }}>Precio</small></Col>
                <Col md={1}></Col>
              </Row>
              {partidas.map((p) => (
                <Row key={p.id} className="align-items-center" style={{ marginBottom: 6 }}>
                  <Col md={4}>
                    <Input type="select" bsSize="sm" value={p.telas} onChange={(e) => setPartida(p.id, "telas", e.target.value)}>
                      <option value="">Selecciona material...</option>
                      {telas
                        .filter((t) => t.is_active === "Si")
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((t) => (
                          <option key={t._id} value={t._id}>{t.nombre}</option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={2}>
                    <Input type="select" bsSize="sm" value={p.colores} onChange={(e) => setPartida(p.id, "colores", e.target.value)}>
                      <option value="">Color...</option>
                      {(p.arrayColores || [])
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((c) => (
                          <option key={c._id} value={c._id}>{c.name}</option>
                        ))}
                    </Input>
                  </Col>
                  <Col md={1}>
                    <Input type="text" bsSize="sm" value={p.unidad} disabled />
                  </Col>
                  <Col md={2}>
                    <Input type="number" bsSize="sm" placeholder="Cantidad" value={p.cantidad} onChange={(e) => setPartida(p.id, "cantidad", e.target.value)} />
                  </Col>
                  <Col md={2}>
                    <Input type="number" bsSize="sm" placeholder="Precio" value={p.precio} onChange={(e) => setPartida(p.id, "precio", e.target.value)} />
                  </Col>
                  <Col md={1}>
                    <Button size="sm" color="danger" disabled={partidas.length === 1} onClick={() => removePartida(p.id)}>
                      <i className="fas fa-minus"></i>
                    </Button>{" "}
                    <Button size="sm" color="info" onClick={addPartida}>
                      <i className="fas fa-plus"></i>
                    </Button>
                  </Col>
                </Row>
              ))}
              <br />
              <div style={{ textAlign: "right", fontWeight: 600 }}>
                Subtotal: ${subtotal.toLocaleString("es-MX")} &nbsp;|&nbsp; IVA: ${iva.toLocaleString("es-MX", { maximumFractionDigits: 2 })} &nbsp;|&nbsp; Total: ${total.toLocaleString("es-MX", { maximumFractionDigits: 2 })}
              </div>
              <div className="submit-bar">
                <Button href="/ListadoCompras" className="btn btn-danger" id="botonListado">
                  Regresar
                </Button>
                <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
                  <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
                </Button>
              </div>
            </Form>
          </div>
        ) : undefined}
      </div>
    </>
  );
}

export default CompraDirectaCreate;
